import { action, computed, makeObservable, observable } from 'mobx';

import { UserData } from 'chaika-frontend-types/frontend-cms';

import { ReservationList } from '@store/models/ReservationList';

import { UserProfile } from './UserProfile';

export class User extends UserProfile {
    @observable public reservationList = new ReservationList();
    @observable public practiceDoctorIds?: string[];

    constructor(user: UserData = {} as UserData) {
        super(user);
        makeObservable(this);
    }

    @computed
    public get organizationIds(): string[] {
        return !!this.mainOrganizationId ? [this.mainOrganizationId] : [];
    }

    @action
    public setPracticeDoctorsIds(ids: string[]): void {
        this.practiceDoctorIds = ids;
    }
}
